import React, { useState, useEffect, useContext } from 'react';
import { LegacyStack, Tabs } from '@shopify/polaris';
import SubscriptionRow from './SubscriptionRow'
import StudentRow from './StudentRow'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { StudentsContext } from '../../contexts/Students'
import { UserContext } from '../../contexts/yolk/User'
import { ErrorBoundary } from "react-error-boundary";

export default function StudentsTable(props) {
  const allSubscriptions = useContext(SubscriptionsContext);
  const students = useContext(StudentsContext);
  const [user] = useContext(UserContext);
  const subscriptions = allSubscriptions.filter((subscription) => subscription.isStudentCourse(user))

  // sort students by lastname
  students.sort((a, b) => {
    var lastNameA = (a.last_name).toLowerCase();
    var lastNameB = (b.last_name).toLowerCase();
    return lastNameA < lastNameB ? -1 : 1;
  })

  return students.map((student, index) => {
    const name = `${student.first_name} ${student.last_name}`
    const studentRow = <StudentRow key={student.id} index={index} name={name} email={student.email}/>
    const studentSubscriptions = subscriptions.filter((s) => s.belongsTo(student.username))
    const subscriptionRows = studentSubscriptions.map((s, index) => <ErrorBoundary fallback={<div>Something went wrong</div>}><SubscriptionRow key={`${s.id}_${index}`} id={s.id} /></ErrorBoundary>)
    return (<table className="responsive subscriptions" key={student.id}><tbody>{[studentRow].concat(subscriptionRows)}</tbody></table>)
  })
}
